import React from "react";

const UserFilter = ({ setRoleId, setCurrentPage,setSelectedIds }) => {
  return (
    <div className="">
      <label className="m-0" style={{fontSize: 12}}>Select Role: </label>
      <select
      className="d-block w-100 rounded-3 border p-2"
      style={{backgroundColor: "#efefef", height: 50}}
        onChange={(e) => {
          setRoleId(e.target.value);
          setCurrentPage(1);
          setSelectedIds([])
        }}
      
      >
         <option value="">All</option>
        <option value="1">Patient</option>
        <option value="2">Doctor</option>
        <option value="3">Chemist</option>
      </select>
    </div>
  );
};

export default UserFilter;
